<template>
  <modal name="lightbox" adaptive height="auto">
    <Wrapper>
      <div class="lightbox">
        <img :src="url" />
        <div class="btn--bar">
          <span class="btn btn--secondary" @click="$emit('hideModal')"><i class="icon--cancel"></i> {{ $t('general.close') }}</span>
        </div>
      </div>
    </Wrapper>
  </modal>
</template>

<script>
import Wrapper from '@/components/Modal/Wrapper'

export default {
  name: 'Lightbox',
  components: { Wrapper },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
